import React from 'react';
import HrbTranslate from '../../../components/language/HrbTranslate';


const OfficeListNoResults = () => (
    <div className="columns light-grey">
        <div className='column is-12 has-text-centered'>
            <HrbTranslate className='p1 pb-4' text='QueuePage.Labels.None' />
        </div>
    </div>
);

export default OfficeListNoResults